export const defaultWishlistConfig = () => {
    return {
        key: 'wishlist',
        activeClass: 'border-bg-highlight',
        stats: {send: true},
        onAdd: function($self) {
            const position = $self.offset();
            const msg = __('add_to_wishlist_msg');
            const $messageBox = $('#headerMessagesBox');
            const $ciMessage = $('.ci-message');

            window.initCiMessage($ciMessage, $messageBox).then(() => {
                window.$ciMessage.displayMessage(msg, 'body',
                    {position: 'absolute', top: (position.top + ($self.outerHeight() / 2)) + 'px', left: position.left + 'px'}
                );
                window.$ciMessage.displayMessage(msg, $messageBox, {position: 'absolute', top: '0px', left: '0px'});
            });
        }
    }
}